import { render } from "./list.vue?vue&type=template&id=77e145d3&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=77e145d3&scoped=true&lang=css"
import "./list.vue?vue&type=style&index=1&id=77e145d3&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e145d3"]])

export default __exports__